// footerStyles.js

export const containerStyles = {
    width: "100%",
    padding: 0,
  };
  
  export const mainBoxStyles = {
    width: "100%",
    minHeight: "40vh",
    pt: 5,
    background: "#007447",
    backgroundSize: "cover",
    backgroundPosition: "center",
    marginTop: "100px",
  };
  
  export const logoBoxStyles = {
    display: "flex",
    alignItems: "center",
    ml: { xs: 4 },
  };
  
  export const logoImageStyles = {
    width: "40px",
    height: "40px",
    mr: 1,
  };
  
  export const logoTextStyles = {
    fontFamily: "Century Gothic",
    fontWeight: 700,
    color: "#FFFFFF",
    fontSize: '24px',
  };
  
  export const contactTextStyles = {
    fontFamily: "Poppins, Arial, sans-serif",
    fontWeight: 600,
    fontSize: '16px',
    color: "#FFFFFF",
    mt: 1,
    textAlign: 'start',
  };
  
  export const socialIconStyles = {
    width: "40px",
    height: "40px",
    mr: 2,
  };
  
  export const sectionTitleStyles = {
    fontFamily: "Poppins, Arial, sans-serif",
    fontWeight: 600,
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: 'start'
  };
  
  export const linkTextStyles = {
    fontFamily: "Poppins, Arial, sans-serif",
    fontWeight: 600,
    fontSize: '16px',
    color: "#FFFFFF",
    mb: 2,
     textAlign: 'start',
  };
  
  export const buttonStyles = {
    // width: '230px',
    backgroundColor: "#ffff",
    color: "#0D8B5A",
    padding: "4px 18px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    borderRadius: '14px',
    border: '2px solid #0D8B5A',
    boxShadow: '0px 4px 4px 0px #00000040',
    "&:hover": {
      backgroundColor: "#fff",
    },
  };
  
  export const boxStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  };
  
  export const typographyStylesGetItOn = {
    fontSize: "14px",
    fontWeight: 500,
  };
  
  export const typographyStylesGooglePlay = {
    fontSize: "22px",
    fontWeight: 500,
    marginLeft: "0px",
  };
  
  export const footerBarStyles = {
    background: '#0D8B5A',
    py: 1,
  };
  
  export const footerTextStyles = {
    fontFamily: "Poppins, Arial, sans-serif",
    fontWeight: 600,
    color: "#FFFFFF",
    fontSize: '16px',
  };
  